var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.693 3.97v-.628H8.69A2.784 2.784 0 005.914.636h-.002a2.784 2.784 0 00-2.775 2.643v.048l-.003.642H1.476a.375.375 0 00-.374.35l-.476 6.904a.375.375 0 00.374.4h10a.375.375 0 00.374-.4l-.476-6.905a.375.375 0 00-.374-.349H8.693zm-2.78-2.584a2.035 2.035 0 00-2.03 2.03v.553h4.06v-.553a2.035 2.035 0 00-2.03-2.03zM1.49 9.593l-.088 1.28h9.196l-.088-1.28H1.49zm8.968-.75H1.542l.284-4.124h8.348l.284 4.124z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 5.01a.375.375 0 10.75 0h-.75zm0-1v1h.75v-1h-.75zM7.945 5.01a.375.375 0 10.75 0h-.75zm0-1v1h.75v-1h-.75z",
    fill: "#fff"
  })));
}
export default SvgBag;